<template>
    <div class="af" >
        <div class="flex" id="toolH">
            <!--<el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    clearable
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>
            <el-input  class="marr4" style="width: 195px"  v-model="vc_search" placeholder="请输入批次号/品名搜索" clearable size="mini"></el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>-->
            <el-form ref="form" :model="form" label-width="100px" size="mini" inline>
                <el-form-item :label="$t('invoiceReview_invoice_quantity')" v-if="i_isfrom==1">
                    <span>{{form.f_bcfpnum}}</span>
                </el-form-item>
                <el-form-item :label="$t('invoiceReview_tax_exclusive_amount_of_invoice')">
                    <span>{{form.f_pay_ws}}</span>
                </el-form-item>
                <el-form-item :label="$t('invoiceReview_invoice_tax_amount')">
                    <span>{{form.f_pay_zzs}}</span>
                </el-form-item>
            </el-form>
            <el-form ref="form" :model="remainingAmount" label-width="100px" size="mini" inline>
                <el-form-item :label="$t('invoiceReview_remaining_quantity')"  v-if="i_isfrom==1">
                    <span>{{ remainingAmount.f_currentrelate_num_fp }}</span>
                </el-form-item>
                <el-form-item :label="$t('invoiceReview_remaining_amount')">
                    <span>{{ remainingAmount.f_je_ws }}</span>
                </el-form-item>
                <el-form-item :label="$t('invoiceReview_remaining_tax_amount')">
                    <span>{{ remainingAmount.f_je_zzs}}</span>
                </el-form-item>
            </el-form>
        </div>
        <el-table
                v-loading="loading"
                v-if="showTable"
                border
                :data="tableData"
                class="el-child-table marT10"
                ref="table"
                size="mini"
                :height="tableHeight"
                style="width: 100%"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                @select="select"
                @selection-change="handleSelectionChange"
                :row-key="row => row.uniqueKey"
                :default-selection="defaultSelectedRows"
                show-summary
                :summary-method="getSummaries"
        >
            <el-table-column
                    type="selection"
                    :selectable="checkSelectable"
                    :reserve-selection="true"
                    width="50">
            </el-table-column>
            <el-table-column
                    type="index"
                    label=""
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="i_order_type"
                    :label="$t('invoiceReview_type')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.i_order_type==1?$t('invoiceReview_warehousing_receipt'):(scope.row.i_order_type==2?$t('invoiceReview_in_transit_loss_order'):(scope.row.i_order_type==3?$t('invoiceReview_in_transit_order'):''))}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="i_order_pid"
                    :label="$t('invoiceReview_document_no')"
                    show-overflow-tooltip
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip
                    width="130">
            </el-table-column>
            <el-table-column
                    prop="vc_no"
                    :label="$t('form_batch_number')"
                    show-overflow-tooltip
                    width="130">
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_num_tol"
                    :label="$t('invoiceReview_total_order_quantity')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_unit"
                    :label="$t('form_unit')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_fkpay_tol"
                    :label="$t('invoiceReview_total_paid_amount_of_order')"
                    show-overflow-tooltip
                    width="110">
            </el-table-column>
            <!--<el-table-column
                    align="right"
                    prop="f_related_num"
                    label="已关联发票数量"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_canrelate_num"
                    label="可关联发票数量"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="f_currentrelated_num"
                    :label="$t('invoiceReview_currently_associated_quantity')"
                    show-overflow-tooltip
                    width="130">
                <template slot-scope="scope">
                    <el-input-number disabled @change="inbcfnum(tableData,scope.$index,scope.row)"  :controls="false" :precision="$setPrecision.quantityPrecision" size="mini" v-model="scope.row.f_currentrelated_num" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_bl"
                    :label="$t('invoiceReview_ratio')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_fpunit"
                    :label="$t('invoiceReview_invoice_unit')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_currentrelate_num_fp"
                    :label="$t('invoiceReview_invoice_quantity')"
                    show-overflow-tooltip
                    width="130">
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_price_ws"
                    :label="$t('invoiceReview_invoice_unit_price')"
                    show-overflow-tooltip
                    width="130">
                <template slot-scope="scope">
                    <span v-if="i_isfrom==1">{{scope.row.f_price_ws}}</span>
                    <el-input-number v-else disabled @change="inprice(tableData,scope.$index,scope.row)" :controls="false" :precision="2" size="mini" v-model="scope.row.f_price_ws" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_je_ws"
                    :label="$t('invoiceReview_tax_exclusive_amount_of_invoice')"
                    show-overflow-tooltip
                    width="130">
                <template slot-scope="scope">
                    <el-input-number disabled @change="inpayws(tableData,scope.$index,scope.row)"  :controls="false" :precision="2" size="mini" v-model="scope.row.f_je_ws" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_sl"
                    :label="$t('form_tax_rate')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_je_zzs"
                    :label="$t('invoiceReview_tax')"
                    show-overflow-tooltip
                    width="130">
                <template slot-scope="scope">
                    <el-input-number disabled @change="inpayzzs(tableData,scope.$index,scope.row)"  :controls="false" :precision="2" size="mini" v-model="scope.row.f_je_zzs" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column  align="center"  width="50">
               <template  slot-scope="scope" >
                   <div class="iconminus">
                       <span class="minus"  @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                   </div>
               </template>
           </el-table-column>
        </el-table>
        <!--<el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[500, 1000, 1500]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>-->
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button  v-if="i_checkstate==0" type="primary" @click="confirm"  :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {
        },
        props: {
            dataOrd: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                maxDialogHeight:0,
                dataZt:{},
                dialogVisible:false,
                tableHeight: 400,
                loading:false,
                dt_startdate:'',
                dt_enddate:'',
                vc_search:"",
                valuetime:'',
                baseerp: "",
                mid: 0,
                expend:false,
                showTable:true,
                tableData: [],
                multipleSelection: [],
                pageSize: 500,
                currentPage: 1,
                tableTotal: 0,
                highlightCurrentRow: false,
                currentInvoiceId: null,
                selectedPid: null,
                form:{},
                selectedTotal: {
                    f_currentrelate_num_fp: 0,
                    f_je_ws: 0,
                    f_je_zzs: 0
                },
                i_isfrom:null,
                i_checkstate:0,
            }
        },
        updated() {
            if(this.$refs.table && this.$refs.table.doLayout){
                this.$refs['table'].doLayout();
            }

        },
        computed: {
            defaultSelectedRows() {
                // 返回当前选中的数据用于 default-selection
                return this.multipleSelection;
            },
            remainingAmount() {
                //console.log('??')
                return {
                    f_currentrelate_num_fp: parseFloat((this.form.f_bcfpnum - this.selectedTotal.f_currentrelate_num_fp).toFixed(this.$setPrecision.quantityPrecision)),
                    f_je_ws: this.keepTwoDecimal(this.form.f_pay_ws - this.selectedTotal.f_je_ws),
                    f_je_zzs: this.keepTwoDecimal(this.form.f_pay_zzs - this.selectedTotal.f_je_zzs)
                };
            }
        },
        mounted() {
            //console.log("dataOrd", this.dataOrd);
            this.tableData=this.deepClone(this.dataOrd.row.details);
            //console.log("this.tableData", this.tableData);
            //console.log("remainingAmount", this.remainingAmount);
            this.form=this.dataOrd.row;
            this.i_isfrom=this.dataOrd.i_isfrom;
            this.currentInvoiceId = this.dataOrd.index;
            this.i_checkstate=this.dataOrd.i_checkstate;
            this.fppay=(this.dataOrd.row.f_pay_ws+this.dataOrd.row.f_pay_zzs).toFixed(this.$setPrecision.quantityPrecision);
            //console.log(this.fppay,'this.fppay')
            this.$nextTick(() => {
                const table = this.$refs.table;
                if (table) {
                    this.tableData.forEach(row => {
                        const isSelected = this.dataOrd.row.details.some(sel => sel.uniqueKey == row.uniqueKey);
                        table.toggleRowSelection(row, isSelected);
                        if(isSelected){
                            this.multipleSelection.push(row);
                            //console.log(this.multipleSelection,'this.multipleSelection');
                            this.changeselT()
                        }
                    });
                }
                this.updateTableHeight();
                window.addEventListener('resize', this.updateTableHeight);
            });

            //this.getOrders(0);
            this.baseerp = baseerp;

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
        },
        methods: {
            updateTableHeight() {
                //console.log(this.dataOrd.maxDialogHeight,'this.dataOrd.maxDialogHeight');
                const dialogHeight = this.dataOrd.maxDialogHeight * 0.9; // 弹窗最大高度
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight = 300;
                this.tableHeight = dialogHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight=dialogHeight;
            },
            deleteRow(value, index) {
                const islossrelate = this.multipleSelection.find(item => item.uniqueKey === value.uniqueKey);
                const idx = this.multipleSelection.findIndex(item => item.uniqueKey === value.uniqueKey);
                if (islossrelate) {
                    this.$refs.table.toggleRowSelection(islossrelate, false);
                    this.multipleSelection.splice(idx,1)
                    this.tableData.splice(index, 1);
                    this.changeselT();
                }
            },
            openzt(type) {
                this.dataZt={
                    type:type,
                    remain:this.remainingAmount,
                    select:this.multipleSelection,
                }
                this.dialogVisible=true;
            },
            handleConfirmzt(selectedRows) {
                this.dialogVisible=false;
               // if (selectedRows.type == 'back') {
               // } else {
                    //console.log('最终确认勾选数据:', selectedRows)
                    this.multipleSelection=[];
                    let Data=[...selectedRows,...this.tableData];
                    this.tableData = Data.filter((value, index, self) =>
                        index === self.findIndex((t) => (
                            t.uniqueKey === value.uniqueKey
                        ))
                    );
                    this.$nextTick(() => {
                        const table = this.$refs.table;
                        if (table) {
                            this.tableData.forEach(row => {
                                //const isSelected = this.multipleSelection.some(sel => sel.uniqueKey == row.uniqueKey);
                                table.toggleRowSelection(row, true);
                                //if(!isSelected){
                                    this.multipleSelection.push(row);
                                    //console.log(this.multipleSelection,'this.multipleSelection');
                                    this.changeselT()
                                //}
                            });
                        }
                    });
               // }

            },
            inprice(data,index,row){
                if(row.f_price_ws < 0){
                    row.f_price_ws = 0;
                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceReview_invoice_unit_price_cannot_be_less_than_zero'));
                    this.refreshTable();
                    return ;
                }
                let payws = row.f_currentrelated_num*row.f_bl*row.f_price_ws;
                row.f_je_ws = parseFloat(this.keepTwoDecimal(payws));
                let payzzs = row.f_currentrelated_num*row.f_bl*row.f_price_ws*row.f_sl;
                row.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));
                //console.log(row,'row');
                this.$set(data,index,row);
                this.changeselT()
            },
            inpayws(data,index,row){
                let cenzzs = row.f_currentrelated_num * row.f_price_ws;
                cenzzs = parseFloat(this.keepTwoDecimal(cenzzs));
                //console.log(cenzzs,'cenzzs')
                let more = cenzzs+1;
                let less = cenzzs-1;
                //console.log(more,'more')
                //console.log(less,'less')
                if(row.f_je_ws<less||row.f_je_ws>more){
                    this.$nextTick(()=>{
                        row.f_je_ws = cenzzs;
                    })
                    this.$message.error(this.$t('invoiceReview_the_tax_exclusive_price_cannot_be_higher_or_lower_than_the_standard_price')+cenzzs+"±1！！");
                }
                let fzzs = row.f_je_ws * row.f_sl;
                fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                row.f_je_zzs = fzzs;
                this.$set(data,index,row);
                this.changeselT()
            },
            inpayzzs(data,index,row){
                let cenzzs = row.f_je_ws * row.f_sl;
                cenzzs = parseFloat(this.keepTwoDecimal(cenzzs));
                //console.log(cenzzs,'cenzzs')
                let more = cenzzs+1;
                let less = cenzzs-1;
                //console.log(more,'more')
                //console.log(less,'less')
                if(row.f_je_zzs<less||row.f_je_zzs>more){
                    this.$nextTick(()=>{
                        row.f_je_zzs = cenzzs;
                    })
                    this.$message.error(this.$t('invoiceReview_the_tax_amount_cannot_be_higher_or_lower_than_the_standard_tax_amount')+cenzzs+"±1！");
                }
                this.$set(data,index,row);
                this.changeselT()
            },
            inbcfnum(data,index,row){
                if(row.f_currentrelated_num <= 0){
                    row.f_currentrelated_num = row.f_canrelate_num;
                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceReview_quantity_cannot_be_less_than_or_equal_to_zero'));
                    this.refreshTable();
                    return ;
                }
                if(row.f_currentrelated_num > row.f_canrelate_num){
                    row.f_currentrelated_num = row.f_canrelate_num;
                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceReview_the_quantity_of_this_associated_invoice_cannot_exceed_the_associable_quantity'));
                    this.refreshTable();
                    return ;
                }
                let payws = row.f_currentrelated_num*row.f_bl*row.f_price_ws;
                row.f_je_ws = parseFloat(this.keepTwoDecimal(payws));
                let payzzs = row.f_currentrelated_num*row.f_bl*row.f_price_ws*row.f_sl;
                row.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));
                //console.log(row,'row');
                this.$set(data,index,row);
                this.changeselT()
            },
            keepTwoDecimal(num) {
                const parsed = parseFloat(num);
                if (isNaN(parsed)) return 0;
                return Number(parsed.toFixed(2));
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })

                this.multipleSelection=[];
                this.currentPage=1;
                this.tableData=[];
                this.changeselT();
                this.getOrders(0);
            },

            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                    this.restoreSelection()
                })
            },
            restoreSelection() {
                this.$nextTick(() => {
                    this.multipleSelection.forEach(selectedRow => {
                        const matched = this.tableData.find(item => item.uniqueKey === selectedRow.uniqueKey);
                        if (matched) {
                            this.$refs.table.toggleRowSelection(matched, true);
                        }
                    });
                });
            },
            select(val,row){
                if(this.dataOrd.row.f_fpnum==0&&val.length>1&&this.i_isfrom==1){
                    let idx = this.tableData.findIndex(item=>(item.uniqueKey == row.uniqueKey));
                    this.$refs.table.toggleRowSelection(this.tableData[idx],false)
                    this.$message.error(this.$t('invoiceReview_only_one_order_can_be_selected_for_discount_invoices'));
                    val.pop();
                    return
                }
                const isSelected = val.some(item => item.uniqueKey === row.uniqueKey);
                const islossrelate = this.tableData.find(item => item.i_lossrelate_id === row.i_lossrelate_id&&item.i_order_type==2&&item.uniqueKey!=row.uniqueKey);
                if(isSelected){
                    row.f_currentrelated_num=row.f_canrelate_num>this.form.f_bcfpnum?this.form.f_bcfpnum:row.f_canrelate_num;
                    row.f_currentrelate_num_fp=this.i_isfrom==1?this.form.f_bcfpnum:row.f_canrelate_num;
                    row.f_price_ws=this.i_isfrom==1?this.form.f_price_ws:0;
                    row.f_sl=this.form.f_sl;
                    let payws = row.f_currentrelated_num*row.f_bl*row.f_price_ws;
                    row.f_je_ws = parseFloat(this.keepTwoDecimal(payws));
                    let payzzs = row.f_currentrelated_num*row.f_bl*row.f_price_ws*row.f_sl;
                    row.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));
                    this.multipleSelection = val;
                    //console.log(this.multipleSelection,'val')
                }else{
                    row.f_currentrelated_num=0;
                    row.f_currentrelate_num_fp=0;
                    row.f_price_ws=0;
                    row.f_je_ws=0;
                    row.f_sl=0;
                    row.f_je_zzs=0;
                    const islossrelate = this.tableData.find(item => item.i_lossrelate_id === row.i_lossrelate_id&&item.i_order_type==2&&item.uniqueKey!=row.uniqueKey);
                    if (islossrelate) {
                        this.$refs.table.toggleRowSelection(islossrelate, false);
                    }
                    this.multipleSelection = val;
                    //console.log(this.multipleSelection,'val')
                }
                if (islossrelate) {
                    islossrelate.f_currentrelated_num=islossrelate.f_canrelate_num>this.form.f_bcfpnum?this.form.f_bcfpnum:islossrelate.f_canrelate_num;
                    islossrelate.f_currentrelate_num_fp=this.i_isfrom==1?this.form.f_bcfpnum:islossrelate.f_canrelate_num;
                    islossrelate.f_price_ws=this.i_isfrom==1?this.form.f_price_ws:0;
                    islossrelate.f_sl=this.form.f_sl;
                    let payws = islossrelate.f_currentrelated_num*islossrelate.f_bl*islossrelate.f_price_ws;
                    islossrelate.f_je_ws = parseFloat(this.keepTwoDecimal(payws));
                    let payzzs = islossrelate.f_currentrelated_num*islossrelate.f_bl*islossrelate.f_price_ws*islossrelate.f_sl;
                    islossrelate.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));
                    this.$refs.table.toggleRowSelection(islossrelate, true);
                    this.multipleSelection.push(islossrelate);
                    //console.log(this.multipleSelection,'this.multipleSelection')
                }
                this.changeselT()

            },
            handleSelectionChange(selection) {
                //console.log(selection,'selection')
                if (selection.length === 0) {
                    this.selectedPid = null;
                } else {
                    this.selectedPid = selection[0].i_pz_pid;
                }

            },
            checkSelectable(row, index) {
                //if (this.selectedPid === null) return true;
                //return row.i_pz_pid === this.selectedPid;
            },
            changeselT(){
                this.selectedTotal = {
                    f_currentrelate_num_fp: 0,
                    f_je_ws: 0,
                    f_je_zzs: 0
                };
                this.multipleSelection.forEach(row => {
                    this.selectedTotal.f_currentrelate_num_fp += Number(row.f_currentrelate_num_fp) || 0;
                    this.selectedTotal.f_je_ws += Number(row.f_je_ws) || 0;
                    this.selectedTotal.f_je_zzs += Number(row.f_je_zzs) || 0;
                });
                //console.log(this.selectedTotal,'this.selectedTotal')
            },

            getSummaries({ columns }) {
                //console.log(columns,'columns')
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 1) {
                        sums[index] = '已选';
                        return;
                    }

                    if (['f_currentrelate_num_fp', 'f_je_ws', 'f_je_zzs'].includes(column.property)) {
                        const val = this.selectedTotal[column.property] || 0;
                        sums[index] = column.property=='f_currentrelate_num_fp'?val.toFixed(this.$setPrecision.quantityPrecision):val.toFixed(2);
                    } else {
                        sums[index] = '';
                    }
                });
                return sums;
            },
            // 查询费用列表
            async getOrders(isOrder){
                this.loading=true;
                let param = {
                    'i_mid':this.mid,
                    'i_id':this.dataOrd.i_id,
                    'i_kpkhid':this.dataOrd.i_kpkhid,
                    'i_gsid':this.dataOrd.i_gsid,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'vc_fymx':this.dataOrd.vc_fymx,
                    'i_over':this.i_over,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    'vc_search':this.vc_search,
                    'i_checkstate':this.dataOrd.i_checkstate,
                    'i_isnew':1,
                    'vc_fpunit':this.dataOrd.row.vc_fpunit?this.dataOrd.row.vc_fpunit:'',
                    'isOrder':isOrder,
                };
                let res = await API.getOrderList(param); //getOrderList
                if (res.code == 1) {
                    this.loading=false;
                    this.tableData = res.data.list;
                    this.tableTotal = res.data.total;
                    //console.log(this.tableData);
                    this.$nextTick(() => {
                        const table = this.$refs.table;
                        if (table) {
                            this.tableData.forEach(row => {
                                row.disabled=false;
                                row.f_bl=row.f_bl?row.f_bl:1;
                                row.vc_fpunit=this.dataOrd.row.vc_fpunit;
                                row.f_currentrelate_num_fp=0;
                                row.f_price_ws=0;
                                row.f_je_ws=0;
                                row.f_sl=0;
                                row.f_je_zzs=0;
                                const isSelected = this.dataOrd.row.details.some(sel => sel.uniqueKey == row.uniqueKey);
                                const idx = this.dataOrd.row.details.findIndex(sel => sel.uniqueKey === row.uniqueKey);
                                table.toggleRowSelection(row, isSelected);
                                if(isSelected){
                                    row.f_currentrelate_num_fp=this.dataOrd.row.details[idx].f_currentrelated_num;
                                    row.f_price_ws=this.dataOrd.row.details[idx].f_price_ws;
                                    row.f_je_ws=this.dataOrd.row.details[idx].f_je_ws;
                                    row.f_sl=this.dataOrd.row.details[idx].f_sl;
                                    row.f_je_zzs=this.dataOrd.row.details[idx].f_je_zzs;
                                    row.f_currentrelated_num=this.dataOrd.row.details[idx].f_currentrelated_num;
                                    this.multipleSelection.push(row);
                                    //console.log(this.multipleSelection,'this.multipleSelection');
                                    this.changeselT()

                                }
                            });
                        }
                    });
                    this.updateTableHeight();
                    window.addEventListener('resize', this.updateTableHeight);
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getOrders(0);
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getOrders(0);
            },

            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getOrders(0);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })
                this.multipleSelection=[];
                this.getOrders(0);
            },

            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            confirm() {
                //console.log(this.multipleSelection,'this.multipleSelection')
                if(this.multipleSelection.length==0){
                    this.$message.error(this.$t('invoiceReview_please_select_expense'));
                    return
                }
                let totalnum=0,ids = [];
                let arr = [...this.multipleSelection ]
                arr.forEach(item=>{
                    ids.push(item.uniqueKey),
                    item.f_sl=this.dataOrd.row.f_sl,
                    totalnum += item.f_currentrelate_num_fp;
                })
                if(Number(totalnum)!=Number(this.form.f_bcfpnum)&&this.i_isfrom==1){
                    this.$message.error(this.$t('invoiceReview_the_total_quantity_of_this_associated_invoice_must_be_consistent_with_the_invoice_quantity'));
                    return
                }
                let pay = Number(this.form.f_pay_ws)+Number(this.form.f_pay_zzs);
                let choopay = Number(this.selectedTotal.f_je_ws)+Number(this.selectedTotal.f_je_zzs);
                //console.log(pay,'pay',choopay,'choopay')
                //console.log(this.dataOrd.row.f_fppay_ws,'this.dataOrd.row.f_fppay_ws')
                pay=parseFloat(this.keepTwoDecimal(pay))
                choopay=parseFloat(this.keepTwoDecimal(choopay))
                if(choopay!=pay&&this.dataOrd.row.f_pay_ws>=0){
                    this.$message.error(this.$t('invoiceReview_the_total_tax_inclusive_amount_of_this_associated_invoice_must_be_consistent_with_the_invoice_tax_inclusive_amount'));
                    return
                }
                //console.log(this.multipleSelection,'this.multipleSelection')
                this.$emit('confirm', {
                    invoiceId: this.currentInvoiceId,
                    selections: JSON.parse(JSON.stringify(this.multipleSelection)),
                    ids:ids
                });
            },
            cancel(){
                this.$emit('confirm',{type:'back'});
            },

        }
    }
</script>
<style>
    .el-message-box__message p{
        max-height: 500px !important;
        overflow-y: auto !important;
    }
</style>
<style  lang="scss" scoped>
    /deep/.el-table td.is-right, .el-table th.is-right {
        text-align: right !important;
    }
    /deep/.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 0px !important;
    }
    /* 隐藏 el-table 的全选框 */
   /deep/ .el-table__header-wrapper th .cell .el-checkbox {
        display: none;
    }



    /deep/.el-child-table .el-table__body-wrapper{
        width: 100% !important;
    }
    /deep/.el-table__expanded-cell{
        padding: 3px 3px 3px 48px;
    }
    /*.has-child {
        padding: 0px !important;
        // display: none;
        & > .cell {
            padding: 0 !important;
        }
        ::before {
            height: 0;
        }
        .child-table {
            background-color: transparent;
            .cell{
                line-height: 34px;
            }
        }
        .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
            background-color: transparent;
        }
        .el-table__body tr.current-row > td.el-table__cell,
        .el-table__body tr.selection-row > td.el-table__cell {
            background-color: transparent;
        }
        tr {
            background-color: transparent;
        }
        .child-head {
            display: flex!important;
        }
        /deep/.el-table .el-table__cell{
            padding: 0;
        }
        /deep/.el-table .cell{
            line-height: 34px;
        }
    }*/
    .green{
        color: #67c23a;
    }
    .orange{
        color: #e6a23c;
    }
    .gray{
        color: #909399;
    }
    .red{
        color: #f56c6c !important;
    }

    /deep/.el-table td{
        //text-align: center !important;
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
